import { gql } from "@apollo/client";

const APPLICATION_SETTINGS = gql`
mutation updateApplicationSettings($applicationSettingsInput: ApplicationSettingsInput!) {
    updateApplicationSettings(applicationSettingsInput: $applicationSettingsInput)
}
`;

export default APPLICATION_SETTINGS;
